import { useState } from "react";
import type { ContenuScorecardSaisi } from "@repo/ent-struct";
import { Label, Textarea } from "@repo/ui";
import { ecrireContenuJson, lireContenuJson, restituerRelances } from "./json";

/**
 * Édition brute du contenu. Le texte est local tant qu'il ne se lit pas : une
 * virgule manquante ne doit pas effacer le brouillon, seulement se signaler.
 * Un texte valide remplace le brouillon à chaque frappe, et les règles de
 * `validerScorecard` s'affichent dans le bandeau comme pour le formulaire.
 *
 * L'onglet est démonté quand on le quitte : il repart du brouillon au retour.
 */
export function OngletJson({
  contenu,
  onChange,
}: {
  contenu: ContenuScorecardSaisi;
  onChange: (contenu: ContenuScorecardSaisi) => void;
}) {
  const [texte, setTexte] = useState(() => ecrireContenuJson(contenu));
  const [erreur, setErreur] = useState<string | null>(null);

  const saisir = (valeur: string) => {
    setTexte(valeur);
    const lecture = lireContenuJson(valeur);
    if (lecture.ok) {
      setErreur(null);
      onChange(restituerRelances(lecture.contenu, contenu));
    } else {
      setErreur(lecture.erreur);
    }
  };

  return (
    <div className="space-y-2">
      <Label htmlFor="scorecard-json" className="text-sm text-muted-foreground">
        Les questions et critères ajoutés n'ont pas d'ID : il est attribué à
        l'enregistrement. Ne pas modifier les IDs existants.
      </Label>
      <Textarea
        id="scorecard-json"
        spellCheck={false}
        className="min-h-[60vh] font-mono text-xs"
        value={texte}
        aria-invalid={erreur !== null || undefined}
        onChange={(e) => saisir(e.target.value)}
      />
      {erreur && (
        <p className="text-sm text-destructive" role="alert">
          {erreur} — le brouillon garde la dernière version lisible.
        </p>
      )}
    </div>
  );
}
